"use client";
import { jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import cx from "classnames";
import {
  getTabIndex,
  handleTransitionEnd
} from "@ingka/collapsible-shared";
const Collapsible = (props) => {
  const {
    children,
    className,
    expanded = false,
    prefix = "",
    id,
    onTransitionEnd,
    focusOnExpanded = false,
    ...other
  } = props;
  const contentWrapper = useRef(null);
  const [isFullyClosed, setIsFullyClosed] = useState(!expanded);
  const baseClass = `${prefix}collapsible`;
  const classes = cx(
    baseClass,
    expanded && `${baseClass}--expanded`,
    isFullyClosed && `${baseClass}--closed`,
    className
  );
  useEffect(() => {
    if (expanded) {
      setIsFullyClosed(false);
    }
  }, [expanded]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      id,
      className: classes,
      "aria-hidden": !expanded,
      role: "region",
      tabIndex: getTabIndex(expanded, focusOnExpanded),
      onTransitionEnd: (e) => {
        if (contentWrapper.current) {
          handleTransitionEnd(
            expanded,
            focusOnExpanded,
            contentWrapper.current,
            e,
            setIsFullyClosed,
            onTransitionEnd
          );
        }
      },
      ref: contentWrapper,
      ...other,
      children: /* @__PURE__ */ jsx("div", { className: `${baseClass}__content`, children })
    }
  );
};
var Collapsible_default = Collapsible;
export {
  Collapsible_default as default
};
